
import { COOKIE_NEXT_LOCALE } from 'consts/cookies';
import { LOCALE_DEFAULT } from 'consts/locales';
import { getProvider } from 'services/Cookies';

export const select = (translationsObject: object): any => {
    const selectedLang = getProvider().get(COOKIE_NEXT_LOCALE) || null;
    let selectedObject = translationsObject[selectedLang];

    if(!selectedObject) {
        selectedObject = translationsObject[LOCALE_DEFAULT];
    }

    if(!selectedObject || Object.keys(selectedObject).length === 0) {
        return {};
    }

    const firstKey = Object.keys(selectedObject)[0];
    return selectedObject[firstKey];
};
